"use strict";

import axios from "axios";
// import AppConfig from "../app.config";
import Vue from "vue";

axios.interceptors.request.use(
  (config) => {
    // loading
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.resolve(error.response);
  }
);

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: "网络异常",
  };
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    console.log(res.msg);
  }
  if (res.data && res.data.errcode != 0) {
    res.data.error_msg && console.log(res.data.error_msg);
  }
  return res.data;
}

const getBaseUrL = () => {
  let api;
  api = `${window.VUE_APP_API_ROOT}`;
  // if (
  //   typeof window != "undefined" &&
  //   window.location.hostname === "localhost"
  // ) {
  //   api = `${window.location.origin}/`;
  // } else {
  //   api = `${process.env.VUE_APP_API_ROOT}`;
  // }
  // console.log("process.env.VUE_APP_API_ROOT", process.env.VUE_APP_API_ROOT);
  return api;
};

export default {
  post(url, data) {
    // var qs = require("qs");
    if (data == undefined) {
      data = {};
    }
    data.iswx = 0;
    data.iswx = Vue.prototype.browser.wx;
    if (data.no_iswx) {
      delete data.iswx;
      delete data.no_iswx;
    }
    return axios({
      method: "post",
      baseURL: getBaseUrL(),
      url,
      data: data,
      timeout: 10000,
      // headers: {
      //   'X-Requested-With': 'XMLHttpRequest',
      //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      // },
      withCredentials: true, //解决跨域cookie问题
    })
      .then((response) => {
        return checkStatus(response);
      })
      .then((res) => {
        return checkCode(res);
      });
  },
  get(url, params) {
    if (params == undefined) {
      params = {};
    }
    params.iswx = 0;
    params.iswx = Vue.prototype.browser.wx;
    return axios({
      method: "GET",
      baseURL: getBaseUrL(),
      url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        //  'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true, //解决跨域cookie问题
    })
      .then((response) => {
        return checkStatus(response);
      })
      .then((res) => {
        return checkCode(res);
      });
  },
};
